import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule as MatTabsModule } from '@shared/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MonacoEditorModule } from '@shared-modules/monaco-editor';
import { GridsterModule } from 'angular-gridster2';
import { CustomWidgetBuilderComponent } from './custom-widget-builder.component';
import { CustomWidgetModule } from '../custom-widget';
import { SlideToggleModule as MatSlideToggleModule } from '@shared/material';
import { ButtonModule as MatButtonModule } from '@shared/material/button';
import { MaterialModule } from '@shared/material';

@NgModule({
  declarations: [CustomWidgetBuilderComponent],
  exports: [CustomWidgetBuilderComponent],
  imports: [
    CommonModule,
    MonacoEditorModule,
    MatTabsModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    GridsterModule,
    CustomWidgetModule,
    MatSlideToggleModule,
    MatButtonModule,
  ],
})
export class CustomWidgetBuilderModule {}
